import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageDescription: {
		id: 'servicedesk.knowledge-hub.common.applink-authentication.authentication-panel.page-description',
		defaultMessage: 'Authenticate with Confluence to access articles from your linked spaces.',
		description: 'Message for agent to authenticate to confluence server.',
	},
	primaryAction: {
		id: 'servicedesk.knowledge-hub.common.applink-authentication.authentication-panel.primary-action',
		defaultMessage: 'Authenticate',
		description: 'Action for agent to authenticate to confluence server.',
	},
});
